<template>
  <nav
    class="flex items-center w-full mx-auto py-[16px] gap-[6px]"
    aria-label="Breadcrumb"
  >
    <Button
      hierarchy="tertiary"
      size="sm"
      :prefix-icon="homeIcon"
      class="!h-8 !w-8 !min-w-0 shrink-0 !p-0 justify-center !rounded-none hover:!rounded-none !border-0 hover:!border-0 hover:!shadow-none !bg-transparent hover:!bg-transparent !text-[#475569] hover:!text-[#2663a3]"
      aria-label="Beranda"
      @click="navigateTo('/')"
    />
    <IconChevronRight :size="14" class="shrink-0 text-slate-300" />
    <Breadcrumb class="revamp-breadcrumb min-w-0" :items="items" />
  </nav>
</template>
<script setup>
import { Breadcrumb, Button } from "@idds/vue";
import { IconHome, IconChevronRight } from "@tabler/icons-vue";

const homeIcon = h(IconHome, { size: 18, strokeWidth: 1.75 });

const route = useRoute();
const items = ref([]);
function findPath() {
  const segments = route.path.split("/").filter((segment) => segment !== "");
  const breadcrumbs = [];
  segments.reduce((prev, curr) => {
    // "portal-pembelajaran" -> "Portal Pembelajaran"
    const label = curr
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
    const href = prev + "/" + curr;
    breadcrumbs.push({ label, href });
    return href;
  }, "");
  if (segments.includes("terjadwal") || segments.includes("terintegrasi")) {
    items.value = breadcrumbs.map((breadcrumb, index, array) => {
      if (index === array.length - 1) {
        return { ...breadcrumb };
      }
      if (index > 1 && array.length > 2) {
        const queryString = route.query.batchId
          ? `?batchId=${route.query.batchId}`
          : "";
        return {
          ...breadcrumb,
          href: breadcrumb.href + queryString,
        };
      }
      return breadcrumb;
    });
    return;
  }
  items.value = breadcrumbs;
}
onMounted(() => {
  findPath();
});
watch(
  () => route.fullPath,
  () => {
    findPath();
  },
  { immediate: true },
);
</script>

<style>
/* Soft, quiet trail: grey links, the current page in brand blue */
.revamp-breadcrumb .ina-breadcrumb__link {
  font-size: 13px;
  color: #64748b;
  text-underline-offset: 3px;
}
.revamp-breadcrumb .ina-breadcrumb__link:hover:not(.ina-breadcrumb__link--active) {
  color: #2663a3;
}
.revamp-breadcrumb .ina-breadcrumb__link--active {
  color: #0f2a4a;
  font-weight: 600;
}
.revamp-breadcrumb .ina-breadcrumb__separator {
  margin: 0 2px;
  color: #cbd5e1;
}
</style>
